import React from 'react';
import { fieldTypes, dataTypes, getData } from 'components/course';

const LiveHardestHole = ({ title, hole, currentRound }) => {
    const isUnderData = getData(hole, fieldTypes.rounds, dataTypes.holePercUnder, currentRound);
    const isParData = getData(hole, fieldTypes.rounds, dataTypes.holeParPerc, currentRound);
    const isOverData = getData(hole, fieldTypes.rounds, dataTypes.holePercOver, currentRound);

    const getValue = (data) => {
        if (!data) data = 0;
        return data;
    };

    const isUnderStyle = {
        height: `${getValue(isUnderData)}%`
    };

    const isParStyle = {
        height: `${getValue(isParData)}%`
    };

    const isOverStyle = {
        height: `${getValue(isOverData)}%`
    };

    return (
        <div className="live-hardest-hole">
            <div className="live-hardest-hole__title">{title}</div>
            <div className="live-hardest-hole__list">
                <div className="live-hardest-hole__item is-under">
                    <div className="live-hardest-hole__item-bar">
                        <div className="live-hardest-hole__item-percent">{getValue(isUnderData)}%</div>
                        <div className="live-hardest-hole__item-bar-value" style={isUnderStyle}>
                        </div>
                    </div>
                    <div className="live-hardest-hole__item-title">under</div>
                </div>
                <div className="live-hardest-hole__item is-par">
                    <div className="live-hardest-hole__item-bar">
                        <div className="live-hardest-hole__item-percent">{getValue(isParData)}%</div>
                        <div className="live-hardest-hole__item-bar-value" style={isParStyle}>
                        </div>
                    </div>
                    <div className="live-hardest-hole__item-title">par</div>
                </div>
                <div className="live-hardest-hole__item is-over">
                    <div className="live-hardest-hole__item-bar">
                        <div className="live-hardest-hole__item-percent">{getValue(isOverData)}%</div>
                        <div className="live-hardest-hole__item-bar-value" style={isOverStyle}>
                        </div>
                    </div>
                    <div className="live-hardest-hole__item-title">over</div>
                </div>
            </div>
        </div>
    );
};

export default LiveHardestHole;
